<template>
  <iVideoContainer
    ref="video"
    :src="videoSrc"
    :height="getOptionValue(LayoutHeight)"
    :min-height="getOptionValue(MinHeight)"
    :max-height="getOptionValue(MaxHeight)"
    :width="getOptionValue(LayoutWidth)"
    :min-width="getOptionValue(MinWidth)"
    :max-width="getOptionValue(MaxWidth)"
    :autoplay="getOptionValue(Autoplay) === 'whenScrolledIntoView'"
    :controls="getOptionValue(Controls)"
    :toggle-on-press="!gestureOwnsTheClick"
    :muted="getOptionValue(Muted)"
    :loop="getOptionValue(Loop)"
    :poster="posterSrc"
    :border-top="myBorderSides?.top ?? 0"
    :border-bottom="myBorderSides?.bottom ?? 0"
    :border-left="myBorderSides?.left ?? 0"
    :border-right="myBorderSides?.right ?? 0"
    :style-overrides="videoStyleOverrides"
  />
</template>

<script>
import { StandardVideoElementMixin } from
  "%/dynamic-components/render-engine/components/production/elements/video-element/standard-video-element-mixin";
import { SingleVideoElementMixin } from "%/dynamic-components/render-engine/components/production/elements/video-element/single-video-element-mixin";
import {
  OptionMediaResolverMixin,
} from "%/dynamic-components/render-engine/mixins/production/option-media-resolver-mixin";

export default {
  name: "VideoElement",
  elementPanelSettings: {
    displayName: "Video",
    elementGroup: "general",
    displayIcon: "video",
    elementType: "element",
  },
  mixins: [StandardVideoElementMixin, SingleVideoElementMixin, OptionMediaResolverMixin],
  computed: {
    // Source + poster are stored either as a media_id (resolved to a fresh HLS/
    // source/WebP URL at render) or a legacy baked URL (used directly).
    // iVideoContainer handles HLS-vs-progressive from the URL.
    videoSrc() {
      return this.resolveOptionMedia(this.getOptionValue(this.SingleVideo));
    },
    posterSrc() {
      return this.resolveOptionMedia(this.getOptionValue(this.Poster));
    },
  },
};
</script>

<style scoped lang="scss">
</style>
